import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import img from "./all_bg.jpg";

const BACKEND_URL = "https://api.bbsfacultyprofile.com";
const TABLE_NAME = "consultation_services";

const ConsultationServices = () => {
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [formData, setFormData] = useState({
    starting_date: null,
    ending_date: null,
    role: "",
    name_of_client: "",
    total_hour: "",
    industry: "",
    country: "",
  });
  const [recordId, setRecordId] = useState(null);

  const fetchRecords = async () => {
  try {
    const res = await fetch(`${BACKEND_URL}/api/${TABLE_NAME}`, {
      method: "GET",
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to fetch records");

    const data = await res.json();

    const processed = data
  .map((rec) => ({
    ...rec,
    starting_date: rec.starting_date
      ? new Date(rec.starting_date)
      : null,
    ending_date: rec.ending_date
      ? new Date(rec.ending_date)
      : null,
  }))
  .sort((a, b) => {
    if (!a.starting_date) return 1;
    if (!b.starting_date) return -1;
    return b.starting_date - a.starting_date;
  });

setRecords(processed);
  } catch (err) {
    toast.error(`Fetch error: ${err.message}`);
  }
};
  useEffect(() => {
    fetchRecords();
  }, []);

  const handleTextChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        starting_date: formData.starting_date
          ? `${formData.starting_date.getFullYear()}-${String(
              formData.starting_date.getMonth() + 1
            ).padStart(2, "0")}-01`
          : null,

        ending_date: formData.ending_date
          ? `${formData.ending_date.getFullYear()}-${String(
              formData.ending_date.getMonth() + 1
            ).padStart(2, "0")}-01`
          : null,
      };

      const url = recordId
        ? `${BACKEND_URL}/api/${TABLE_NAME}/${recordId}`
        : `${BACKEND_URL}/api/${TABLE_NAME}`;
      const method = recordId ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed to save record");

      toast.success("Record saved successfully!");

      setFormData({
        starting_date: null,
        ending_date: null,
        role: "",
        name_of_client: "",
        total_hour: "",
        industry: "",
        country: "",
      });

      setRecordId(null);
      fetchRecords();
    } catch (err) {
      toast.error(`Submit error: ${err.message}`);
    }
  };

  const handleEdit = (record) => {
  setFormData({
    starting_date: record.starting_date,
    ending_date: record.ending_date,
    role: record.role || "",
    name_of_client: record.name_of_client || "",
    total_hour: record.total_hour || "",
    industry: record.industry || "",
    country: record.country || "",
  });

  setRecordId(record.id);
  toast.info("Editing record...");
};

  const handleDelete = (record) => {
    const toastId = toast.info(
      <div>
        Delete this record?
        <button
          onClick={async () => {
            try {
              const res = await fetch(
                `${BACKEND_URL}/api/${TABLE_NAME}/${record.id}`,
                { method: "DELETE", credentials: "include" }
              );
              if (!res.ok) throw new Error("Failed to delete record");
              fetchRecords();
              toast.update(toastId, {
                render: "Record deleted successfully!",
                type: "success",
                autoClose: 3000,
              });
            } catch (err) {
              toast.update(toastId, {
                render: `Delete error: ${err.message}`,
                type: "error",
                autoClose: 3000,
              });
            }
          }}
          style={{
            marginLeft: "10px",
            padding: "3px 8px",
            background: "#ef4444",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Confirm
        </button>
      </div>,
      { autoClose: false, closeOnClick: false }
    );
  };


  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "40px 20px",
        fontFamily: "Arial, sans-serif",
        backgroundImage: `url(${img})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <ToastContainer position="top-center" autoClose={3000} />

      <div
        style={{
          maxWidth: "700px",
          margin: "0 auto",
          background: "#fff",
          padding: "30px 40px",
          borderRadius: "10px",
          boxShadow: "0px 0px 12px rgba(0,0,0,0.1)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            color: "#1e3a8a",
            marginBottom: "25px",
          }}
        >
          Consultation Services
        </h2>

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column" }}
        >
          {/* Dates Row */}
          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontWeight: "bold" }}>
                Starting Month/Year (mm/yyyy)
              </label>
              <DatePicker
                selected={formData.starting_date}
                onChange={(date) =>
                  setFormData({ ...formData, starting_date: date })
                }
                dateFormat="MM/yyyy"
                showMonthYearPicker
                placeholderText="Select month/year"
                style={{ width: "100%" }}
              />
            </div>

            <div style={{ flex: 1 }}>
              <label style={{ fontWeight: "bold" }}>
                Ending Month/Year (mm/yyyy)
              </label>
              <DatePicker
                selected={formData.ending_date}
                onChange={(date) =>
                  setFormData({ ...formData, ending_date: date })
                }
                dateFormat="MM/yyyy"
                showMonthYearPicker
                placeholderText="Select month/year"
                style={{ width: "100%" }}
              />
            </div>
          </div>

          {/* Role Dropdown */}
          <div>
            <label style={{ fontWeight: "bold", marginTop: "10px" }}>
              Role
            </label>
            <select
              name="role"
              value={formData.role}
              onChange={handleTextChange}
              style={{
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                width: "100%",
                fontSize: "16px",
              }}
              required
            >
              <option value="">Select</option>
              <option value="Chief Consultant">Chief Consultant</option>
              <option value="Member Consultant">Member Consultant</option>
            </select>
          </div>

          {/* Client Name */}
          <div>
            <label style={{ fontWeight: "bold", marginTop: "10px" }}>
              Client Name
            </label>
            <input
              type="text"
              name="name_of_client"
              value={formData.name_of_client}
              onChange={handleTextChange}
              style={{
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                width: "100%",
              }}
              required
            />
          </div>

          {/* Total Consultation Hours */}
          <div>
            <label style={{ fontWeight: "bold", marginTop: "10px" }}>
              Total Consultation Hours
            </label>
            <input
              type="number"
              name="total_hour"
              value={formData.total_hour}
              onChange={handleTextChange}
              style={{
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                width: "100%",
              }}
              required
            />
          </div>
          {/* Industry */}
          <div>
            <label style={{ fontWeight: "bold", marginTop: "10px" }}>
              Industry
            </label>
            <input
              type="text"
              name="industry"
              value={formData.industry}
              onChange={handleTextChange}
              style={{
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                width: "100%",
              }}
              required
            />
          </div>

          {/* Country */}
          <div>
            <label style={{ fontWeight: "bold", marginTop: "10px" }}>
              Country
            </label>
            <input
              type="text"
              name="country"
              value={formData.country}
              onChange={handleTextChange}
              style={{
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                width: "100%",
              }}
              required
            />
          </div>

          <button
            type="submit"
            style={{
              background: "#3b82f6",
              color: "white",
              padding: "12px",
              border: "none",
              borderRadius: "6px",
              marginTop: "20px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            {recordId ? "Update Record" : "Add Record"}
          </button>
        </form>

        {/* Records Table */}
        {records.length > 0 && (
          <div style={{ marginTop: "30px", overflowX: "auto" }}>
            <h3 style={{ color: "#1e3a8a" }}>Your Records</h3>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "10px",
              }}
            >
              <thead>
                <tr>
                  {[
                    "Starting Date",
                    "Ending Date",
                    "Role",
                    "Client Name",
                    "Total Consultation Hours",
                    "Industry",
                    "Country",
                    "Actions",
                  ].map((h) => (
                    <th
                      key={h}
                      style={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        background: "#f1f5f9",
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {records.map((rec) => (
                  <tr key={rec.id}>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
  {rec.starting_date
    ? `${String(rec.starting_date.getMonth() + 1).padStart(2, "0")}/${rec.starting_date.getFullYear()}`
    : ""}
</td>

                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
  {rec.ending_date
    ? `${String(rec.ending_date.getMonth() + 1).padStart(2, "0")}/${rec.ending_date.getFullYear()}`
    : ""}
</td>

                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {rec.role}
                    </td>

                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {rec.name_of_client}
                    </td>

                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {rec.total_hour}
                    </td>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {rec.industry}
                    </td>

                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {rec.country}
                    </td>

                    <td
                      style={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <button
                        onClick={() => handleEdit(rec)}
                        style={{
                          background: "#2563eb",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          padding: "5px 10px",
                          marginRight: "5px",
                          cursor: "pointer",
                        }}
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(rec)}
                        style={{
                          background: "#ef4444",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          padding: "5px 10px",
                          cursor: "pointer",
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ textAlign: "center", marginTop: "25px" }}>
          <button
            onClick={() => navigate("/dashboard")}
            style={{
              background: "#1e3a8a",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsultationServices;
